module.exports = __webpack_public_path__ + "img/shouye_daiqu@2x.a90068fc.png";